import React, { type ComponentProps } from 'react';
import { ImageBackground } from 'expo-image';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';

import { useImageSourceProps } from '../../../hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const AspectRatioImageBackground = (props: AspectRatioImageProps) => {
  const { style, source, staticSourceUrl, ...imageProps } = props;

  // ─────────────────────────────────────────────────────────────────────

  const imageSourceProps = useImageSourceProps({ source, staticSourceUrl });

  // ─── Styles ──────────────────────────────────────────────────────────

  const imgBackgroundStyles = [styles.img, style];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <ImageBackground
      transition={theme.transitions.image}
      imageStyle={styles.imgContainer}
      style={imgBackgroundStyles}
      {...imageSourceProps}
      {...imageProps}
    />
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  img: {
    width: '100%',
    height: '100%',
  },
  imgContainer: {
    backgroundColor: theme.colors.LINEN,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type AspectRatioImageProps = {
  staticSourceUrl?: string;
} & ComponentProps<typeof ImageBackground>;
